<template>
  <v-footer class="text-center d-flex flex-column ga-2 py-4 my-footer" color="third" height="auto">
        <v-card-title style="z-index: 1;" >{{castellano?'Contratación:':'Kontratazioa:'}}</v-card-title>
    <a style="color:black; z-index: 1;" href="mailto:info@airakamusic.com">info@airakamusic.com</a>

    <v-row :style="'width:100%'"  class="justify-center pa-4">
       <v-img
       max-width="50px"
        :src="logobertikala"
        alt="Logo Burutik"
        loading="lazy"
        @click="$router.push('/')"  
        :style="'cursor:pointer'"
      ></v-img>
        <v-img
       max-width="70px"
        :src="airakalogo"
        loading="lazy"
        :style="'cursor:pointer'"
        @click="openLink('https://airakamusic.com')"
        alt="Airaka Logo"
      ></v-img>
    </v-row>
    <div class="d-flex ga-3">
  <v-btn
      v-for="icon in icons"
      :key="icon.name"
      icon
      @click="openLink(icon.link)"
      density="comfortable"
      variant="text"
    >
      <v-icon size="30">{{ icon.name }}</v-icon>
    </v-btn>
    </div>


    <v-divider class="pa-3" opacity="200" width="100"></v-divider>

    <div class="text-caption  font-weight-regular opacity-60">
      © {{ new Date().getFullYear() }} Ainhoa Quintana
    </div>
  </v-footer>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

import logobertikala from '@/assets/logos/logo-bertikala.svg'
import airakalogo from '@/assets/logos/airaka_logo.png'

const route = useRoute()
const castellano = computed(() => route.path.startsWith('/cas'))

const icons = ref([
  { name: 'mdi-youtube', link: 'https://www.youtube.com/@burutik8666' },
  { name: 'mdi-instagram', link: 'https://www.instagram.com/burutik' },
])



function openLink(url) {
  window.open(url, '_blank')
}
</script>

<style scoped>
  
  .my-footer {
  background-image: url('@/assets/bodegoia1_small.jpg');
  background-size: cover;
  background-position: center top 50%;
  background-repeat: no-repeat;
  width: 100%;
  position:relative;
  max-height: 100vh;
  
}

@media (min-width: 768px) {
  .my-footer {
    background-image: url('@/assets/bodegoia1_med.jpg');
  }
}

@media (min-width: 1024px) {
  .my-footer {
    background-image: url('@/assets/bodegoia1_large.jpg');
  }
}

.my-footer::before {
  content: "";
  position: absolute;
  inset: 0; /* equivale a top:0; right:0; bottom:0; left:0; */
  background:rgba(226, 215, 192, 0.7);
  z-index: 0;
}
  </style>